/* import __COLOCATED_TEMPLATE__ from './inner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellPlanningPriorityCellInnerSignature {
  Args: {
    value: unknown;
  };
}

const CellPlanningPriorityCellInnerComponent =
  templateOnlyComponent<CellPlanningPriorityCellInnerSignature>();

export default CellPlanningPriorityCellInnerComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::PlanningPriorityCell::Inner': typeof CellPlanningPriorityCellInnerComponent;
    'cell/planning-priority-cell/inner': typeof CellPlanningPriorityCellInnerComponent;
  }
}
